export default __webpack_public_path__ + "static/media/star.ae724ef0.svg";